import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import {
  Inline,
  paletteHelper,
  spacingHelper,
  Text,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { trackDisclaimerModalOpen } from '../../../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { ContentBrickWrapper } from '../../../../../app-kit/components/ContentBrick/ContentBrick';
import { DisclaimerIcon } from '../../../../../app-kit/components/DisclaimerIcon/DisclaimerIcon';
import { useModalContext } from '../../../../../contexts/ModalContext/ModalContext';

const DisclaimerBrick = styled(ContentBrickWrapper)`
  background-color: ${paletteHelper('backgroundInformation')};
  padding-top: ${spacingHelper('medium')};
  padding-bottom: calc(${spacingHelper('medium')} + ${spacingHelper('twoExtraSmall')});
  margin-top: ${spacingHelper('extraSmall')};
`;

const DisclaimerBrickText = styled(Text)`
  ${typographyHelper('body01')}
  color: ${paletteHelper('textPrimary')};
`;

const StyledDisclaimerIcon = styled(DisclaimerIcon)`
  &:hover,
  &:focus,
  &:focus-within {
    color: ${paletteHelper('textPrimary')};
    background-color: ${paletteHelper('backgroundPrimaryBase')};
  }
`;

interface SchoolCatchmentDisclaimerBrickProps {
  disclaimerText: string;
}

export const SchoolCatchmentDisclaimerBrick: FunctionComponent<
  SchoolCatchmentDisclaimerBrickProps
> = ({ disclaimerText }) => {
  const { displayModal } = useModalContext();
  return (
    <DisclaimerBrick>
      <Inline>
        <DisclaimerBrickText>{disclaimerText}</DisclaimerBrickText>
        <StyledDisclaimerIcon
          title="Open School Catchment Disclaimer"
          onClick={() => {
            displayModal({ name: 'schoolCatchmentDisclaimer' });
            trackDisclaimerModalOpen({
              inPageSource: 'school_catchments_source___disclaimer_button',
            });
          }}
        />
      </Inline>
    </DisclaimerBrick>
  );
};
